import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

/* Aggressively remove any "Made with Emergent" badge or its injector script
   that may be added to the page by the deployment pipeline. Bundled into
   main.[hash].js so the deploy build cannot strip it. */
(function killEmergentBadge() {
  const remove = () => {
    document
      .querySelectorAll('#emergent-badge, a[href*="app.emergent.sh"]')
      .forEach((el) => el.remove());
    document
      .querySelectorAll('script[src*="assets.emergent.sh/scripts/emergent-main"]')
      .forEach((el) => el.remove());
  };
  remove();
  if (typeof window !== "undefined" && typeof MutationObserver !== "undefined") {
    const obs = new MutationObserver(remove);
    const start = () =>
      document.body && obs.observe(document.body, { childList: true, subtree: true });
    if (document.body) start();
    else document.addEventListener("DOMContentLoaded", start, { once: true });
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
